import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings } from '@/lib/data/data-service';

export function I18nSync() {
  const { i18n } = useTranslation();
  const { data: settings } = useSettings();

  useEffect(() => {
    if (settings?.language && settings.language !== i18n.language) {
      i18n.changeLanguage(settings.language);
    }
  }, [settings?.language]);

  return null;
}
